// FacilityInfo.jsx
import React from 'react';
import { 
  Building2, 
  Factory, 
  Users, 
  Rocket, 
  ArrowRight, 
  Search, 
  Briefcase, 
  Sparkles,
  CheckCircle,
  Zap,
  Globe,
  Shield,
  TrendingUp,
  Award,
  Cpu
} from 'lucide-react';
import './FacilityInfo.css';

const FacilityInfo = () => {
  return (
    <section className="facility-info">
      <div className="facility-container">
        {/* ========== HERO SECTION ========== */}
        <div className="facility-hero">
          {/* Left Side - Text */}
          <div className="facility-hero-left">
            <div className="facility-badge">
              <Sparkles size={16} className="facility-badge-icon" />
              <span>For Facilities</span>
            </div>

            <h1 className="facility-hero-title">
              <span className="facility-hero-title-line1">What is APIC</span>
              <span className="facility-hero-title-line2">ProtoHub for Facilities?</span>
            </h1>

            <div className="facility-hero-content">
              <h2 className="facility-hero-subtitle">
                Your facility. Your machines. <span>More opportunities.</span>
              </h2>

              <p className="facility-hero-description">
                Many manufacturing facilities have advanced machines, skilled teams and 
                valuable technical capabilities — but their capacity is not always fully utilised.
              </p>

              <p className="facility-hero-description">
                APIC ProtoHub creates a digital bridge between these capabilities and 
                innovators who need access to manufacturing infrastructure. Register your 
                facility to showcase capabilities to a larger innovation ecosystem and 
                take on prototype development opportunities.
              </p>
            </div>

            {/* CTA Buttons */}
            <div className="facility-hero-cta">
              <button className="facility-cta-primary">
                <Building2 size={18} />
                <span>Register Your Facility</span>
                <ArrowRight size={18} className="facility-cta-arrow" />
              </button>
              <button className="facility-cta-secondary">
                <Users size={18} />
                <span>Learn More</span>
              </button>
            </div>
          </div>

          {/* Right Side - Image/Stats */}
          <div className="facility-hero-right">
            <div className="facility-hero-image-wrapper">
              <img
                src="https://images.unsplash.com/photo-1581092335871-5f2b5e17cd7a?w=800&h=600&fit=crop&crop=center&auto=format&q=80"
                alt="Modern manufacturing facility"
                className="facility-hero-image"
                loading="lazy"
              />
              
              {/* Floating Stats Card */}
              <div className="facility-float-stats">
                <div className="facility-float-stat-item">
                  <p className="facility-float-stat-value">50+</p>
                  <p className="facility-float-stat-label">Facilities</p>
                </div>
                <div className="facility-float-stat-divider"></div>
                <div className="facility-float-stat-item">
                  <p className="facility-float-stat-value">150+</p>
                  <p className="facility-float-stat-label">Machines</p>
                </div>
                <div className="facility-float-stat-divider"></div>
                <div className="facility-float-stat-item">
                  <p className="facility-float-stat-value">2.5K+</p>
                  <p className="facility-float-stat-label">Innovators</p>
                </div>
              </div>

              {/* Floating Badge */}
              <div className="facility-float-badge">
                <div className="facility-float-badge-icon">
                  <Award size={18} />
                </div>
                <div>
                  <p className="facility-float-badge-title">Verified</p>
                  <p className="facility-float-badge-sub">Trusted Platform</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* ========== BENEFITS SECTION ========== */}
        <div className="facility-benefits">
          <div className="facility-benefits-header">
            <div className="facility-benefits-badge">
              <Zap size={14} className="facility-badge-icon" />
              <span>Why Join</span>
            </div>
            <h3 className="facility-benefits-title">
              Unlock New Opportunities <span>for Your Facility</span>
            </h3>
          </div>

          <div className="facility-benefits-grid">
            {/* Benefit 1 */}
            <div className="facility-benefit-card">
              <div className="facility-benefit-icon-wrapper">
                <div className="facility-benefit-icon">
                  <Search size={24} />
                </div>
              </div>
              <h4 className="facility-benefit-card-title">Get discovered</h4>
              <p className="facility-benefit-card-desc">
                Showcase your facility and capabilities to innovators, startups, 
                industries and government organisations.
              </p>
              <div className="facility-benefit-tag">
                <CheckCircle size={14} />
                <span>Visibility</span>
              </div>
            </div>

            {/* Benefit 2 */}
            <div className="facility-benefit-card featured">
              <div className="facility-benefit-icon-wrapper">
                <div className="facility-benefit-icon">
                  <Briefcase size={24} />
                </div>
              </div>
              <h4 className="facility-benefit-card-title">Get new business opportunities</h4>
              <p className="facility-benefit-card-desc">
                Receive relevant prototype RFQs based on your machines, technologies 
                and registered capabilities.
              </p>
              <div className="facility-benefit-tag">
                <TrendingUp size={14} />
                <span>Growth</span>
              </div>
              <div className="facility-benefit-featured-badge">Popular</div>
            </div>

            {/* Benefit 3 */}
            <div className="facility-benefit-card">
              <div className="facility-benefit-icon-wrapper">
                <div className="facility-benefit-icon">
                  <Globe size={24} />
                </div>
              </div>
              <h4 className="facility-benefit-card-title">Global Network</h4>
              <p className="facility-benefit-card-desc">
                Connect with a larger innovation ecosystem and expand your 
                facility's reach beyond local boundaries.
              </p>
              <div className="facility-benefit-tag">
                <Shield size={14} />
                <span>Trusted</span>
              </div>
            </div>
          </div>
        </div>

        {/* ========== STATS BAR ========== */}
        {/*   </div> */}
        </div>
    
    </section>
  );
};

export default FacilityInfo;